"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsProviders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const ComponentsProviders = ({ children, history }) => {
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Router, { history: history, children: children });
};
exports.ComponentsProviders = ComponentsProviders;
//# sourceMappingURL=provider.js.map